var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.tag, _vm._b({
    tag: "component",
    staticClass: "btn",
    class: [_vm.colorString ? 'btn-' + _vm.colorString : '', _vm.colorModifierClass, _vm.roundedString, _vm.sizeString ? 'btn-' + _vm.sizeString : '', _vm.isActive && _vm.activeColor ? 'btn-' + _vm.activeColor : '', {
      'btn--active': _vm.isActive,
      'btn--disabled': _vm.isDisabled,
      'btn-shadow': _vm.shadow,
      'btn-text': _vm.text,
      'btn-outlined': _vm.outlined,
      'btn-fab': _vm.fab,
      'btn-icon': _vm.icon,
      'btn-plain': _vm.plain,
      'text-white': _vm.colorHex && !_vm.outlined && !_vm.text
    }],
    style: _vm.style,
    attrs: {
      "type": _vm.type,
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, 'component', _vm.linkProps, false), [_vm.showLoadingIcon ? _c('loading-icon') : [_vm._t("default")]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }